import { render, staticRenderFns } from "./voteLogin.vue?vue&type=template&id=14ffd3da"
import script from "./voteLogin.vue?vue&type=script&lang=js"
export * from "./voteLogin.vue?vue&type=script&lang=js"
import style0 from "./voteLogin.vue?vue&type=style&index=0&id=14ffd3da&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports